module.exports = new __parcel__URL__("alturas-de-macchu-picchu.811e5b1b.jpg").toString();